const Routes = {
  LOGIN: '/login',
  FORGOTPASSWORD: '/forgot-password',
  CHANGEPASSWORD: '/change-password',
  HOME: '/home',
  QUOTATIONS: '/quotes',
  NEWQUOTATIONINFO: '/quotes/info/:idProduct/:idOperation?',
  NEWQUOTATIONPLANS: '/quotes/plans/:idProduct/:idOperation',
  PAYMENTS: '/quotes/payments/:idProduct/:idOperation',
  DOCUMENTMANAGEMENT: '/documents/:idProduct/:idOperation',

  TEST1: '/test1',
  TEST2: '/test2',
  // ENQUIRIES: '/enquiries',
  // CREATEENQUIRITY:'/create-enquirity/:idProduct',
  // EDITENQUIRITY:'/edit-enquirity/:idProduct/:idOperation',
  // POLICIES: '/policies',
  // CLAIMS: '/claims',
  // RENEWALS: '/renewals',
  
  //MIRADOR
  PAGE4: '/embed/page4/:idOperation?',
  PAGE5: '/embed/page5/:idOperation',
  PAGE6: '/embed/page6/:idOperation',
  PAGE7: '/embed/page7/:idOperation',
  PAGE8: '/embed/page8/:idOperation',
  PAGE10: '/embed/page10/:idOperation',
  PAGE11: '/embed/page11/:idOperation',
  PAGE12: '/embed/page12/:idOperation',

  //AIO
  AIO: '/embed/aio',
  AIONEWQUOTATIONINFO: '/embed/aio/info/:idProduct/:idOperation?',
  AIONEWQUOTATIONPLANS: '/embed/aio/plans/:idProduct/:idOperation',
  AIOPAYMENTS: '/embed/aio/payments/:idProduct/:idOperation',
  AIOISSUE: '/embed/aio/issue/:idProduct/:idOperation',

};

export default Routes;